import styled from 'styled-components';
import { Input } from 'antd';

export const StyledInputSearch = styled(Input)`
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  color: rgba(22, 23, 26, 1);
  border: 1px solid ${({ theme }) => theme.palette.neutral[300]};

  &.search-input {
    width: 320px;
  }

  .ant-input-prefix {
    margin-inline-end: 8px;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  &.ant-input-outlined:hover,
  &.ant-input-outlined:focus,
  &.ant-input-outlined:focus-within {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }
`;
